<template>
  <div class="research">
    <el-card>
      <div style="display:flex">
        <div class="research-left">
          <div class="research-search">
            <el-cascader class="research-select" clearable v-model="courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
            <!-- <el-cascader
              class="research-select"
              clearable
              v-model="courseIds"
              :show-all-levels="false"
              :props="subjectTreeProps"
              placeholder="请输入所属科目"
              :options="subjectTreeList"
              @change="subjectSearchChange"
            ></el-cascader> -->
            <el-tree :data="ChapterTree" :props="ChapterProps" :default-expanded-keys="[addChapterMaterialsId]" :highlight-current="true" :expand-on-click-node="false" class="research-tree" ref="tree" node-key="id" current-node-key>
              <span class="span-ellipsis" slot-scope="{ node, data }">
                <span :title="data.name" @click="choseChapterId(data);">{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="research-right">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="上课讲义" name="first" class="tab-type">
              <el-table :data="teachingResearchList" border style="width: 100%">
                <el-table-column prop="name" label="章节考点" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{chapterName}}&nbsp;|&nbsp;{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="chapterMaterials.title" label="标准讲义" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.chapterMaterials!=null" type="text" size="small" @click="openNote(scope.row)">{{scope.row.chapterMaterials.title}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="chapterMaterials.title" label="自定义讲义" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <i class="research-icon el-icon-plus" style="margin:10px 0px 0px 0px;float:left;" @click="goZiAddNote(scope.row,3)"></i>
                    <div style="margin-left:20px;" v-for="(item,index) in scope.row.chapterMaterialsList" :key="index">
                      <el-button type="text" size="small" @click="openZiNote(item)">{{item.title}}</el-button>
                      <i class="research-icon-right el-icon-delete" @click="deleteChapterMaterials(item.id,1)"></i>
                      <i class="research-icon-right el-icon-edit" @click="goZiAddNote(item,4)"></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="课堂练习" name="second" class="tab-type">
              <el-table :data="teachingResearchList" border style="width: 100%;">
                <el-table-column prop="name" label="章节考点">
                  <template slot-scope="scope">
                    <span>{{chapterName}}&nbsp;|&nbsp;{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="chapterMaterials.title" label="标准课堂练习" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.chapterMaterials!=null" type="text" size="small">{{scope.row.chapterMaterials.title}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="chapterMaterials.title" label="自定义练习" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <i class="research-icon el-icon-plus" style="margin:10px 0px 0px 0px;float:left;" @click="choseQuestion(scope.row,2)"></i>
                    <div style="margin-left:20px;" v-for="(item,index) in scope.row.chapterMaterialsList" :key="index">
                      <el-button type="text" size="small" @click="goTestQuestions(item,2,scope.row.id)">{{item.title}}</el-button>
                      <i class="research-icon-right el-icon-delete" @click="deleteChapterMaterials(item.id,2)"></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="课后作业" name="third" class="tab-type">
              <el-table :data="teachingResearchList" border style="width: 100%">
                <el-table-column prop="name" label="章节考点">
                  <template slot-scope="scope">
                    <span>{{chapterName}}&nbsp;|&nbsp;{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="materialsCount" label="试题" width="300">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="goTestQuestions(scope.row)"
                    >{{scope.row.materialsCount}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="choseQuestion(scope.row)">从题库中选择</el-button>
                  </template>
                </el-table-column>-->
                <el-table-column prop="chapterMaterials.title" label="标准课后作业" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.chapterMaterials!=null" type="text" size="small">{{scope.row.chapterMaterials.title}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="chapterMaterials.title" label="自定义课后作业" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <i class="research-icon el-icon-plus" style="margin:10px 0px 0px 0px;float:left;" @click="choseQuestion(scope.row,4)"></i>
                    <div style="margin-left:20px;" v-for="(item,index) in scope.row.chapterMaterialsList" :key="index">
                      <el-button type="text" size="small" @click="goTestQuestions(item,2,scope.row.id)">{{item.title}}</el-button>
                      <i class="research-icon-right el-icon-delete" @click="deleteChapterMaterials(item.id,3)"></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="课程视频" v-if="type==1" name="fourth" class="tab-type">
              <el-table :data="teachingResearchList" border style="width: 100%">
                <el-table-column prop="name" label="章节考点">
                  <template slot-scope="scope">
                    <span>{{chapterName}}&nbsp;|&nbsp;{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="videoNum" label="视频" width="300">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="openVideo(scope.row)"
                    >{{scope.row.videoNum}}</el-button>
                  </template>
                </el-table-column>-->
                <el-table-column prop="chapterMaterials.title" label="标准课堂视频" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <!-- <i
                      v-if="scope.row.chapterMaterials == null"
                      class="research-icon el-icon-plus"
                      style="margin:0px"
                      @click="goAddVideo(scope.row,1)"
                    ></i>-->
                    <el-button v-if="scope.row.chapterMaterials!=null" type="text" size="small" @click="openVideo(scope.row)">{{scope.row.name}}</el-button>
                    <!-- <i
                      v-if="scope.row.chapterMaterials!=null"
                      class="research-icon-right el-icon-delete"
                      @click="deleteChapterMaterials(scope.row.chapterMaterials.id)"
                    ></i>
                    <i
                      v-if="scope.row.chapterMaterials!=null"
                      class="research-icon-right el-icon-edit"
                      @click="goAddVideo(scope.row,2)"
                    ></i>-->
                  </template>
                </el-table-column>
                <el-table-column prop="chapterMaterials.title" label="自定义视频" width="300" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <i class="research-icon el-icon-plus" style="margin:10px 0px 0px 0px;float:left;" @click="goAddVideo(scope.row,3)"></i>
                    <div style="margin-left:20px;" v-for="(item,index) in scope.row.chapterMaterialsList" :key="index">
                      <el-button type="text" size="small" @click="openZiVideo(item)">{{item.title}}</el-button>
                      <i class="research-icon-right el-icon-delete" @click="deleteChapterMaterials(item.id,4)"></i>
                      <i class="research-icon-right el-icon-edit" @click="goAddVideo(item,4)"></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <!-- <el-tab-pane label="补充资料" name="five" class="tab-type">
              <el-table :data="teachingResearchList" border style="width: 100%">
                <el-table-column prop="name" label="章节考点">
                  <template slot-scope="scope">
                    <span>{{chapterName}}&nbsp;|&nbsp;{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="materialsCount" label="补充资料" width="300">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="openDataDialogVisible(scope.row)"
                    >{{scope.row.materialsCount}}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

             <el-tab-pane label="PPT" name="six" class="tab-type">
              <el-table :data="teachingResearchList" border style="width: 100%">
                <el-table-column prop="name" label="章节考点">
                  <template slot-scope="scope">
                    <span>{{chapterName}}&nbsp;|&nbsp;{{scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="面授教学4:3" width="120" align="center">
                  <template slot-scope="scope">
                    <i
                      v-if="scope.row.ppt43!=null"
                      class="research-icon el-icon-video-play"
                      style="font-size:16px;"
                      @click="pptPlay(scope.row)"
                    ></i>
                    <el-upload
                      v-if="scope.row.ppt43!=null"
                      style="display:initial"
                      class="upload-demo"
                      :action="fileAction"
                      :on-success="pptHandleSuccess"
                      :headers="reqData"
                      :file-list="fileList"
                    >
                      <el-button
                        type="text"
                        @click="replacePPT(scope.row.ppt43),appendexId = scope.row.id,subject = 'ppt43'"
                      >替换</el-button>
                    </el-upload>
                    <el-upload
                      v-if="scope.row.ppt43==null"
                      style="display:initial"
                      class="upload-demo"
                      :action="fileAction"
                      :on-success="pptHandleSuccess"
                      :headers="reqData"
                      :file-list="fileList"
                    >
                      <i
                        class="research-icon el-icon-upload"
                        style="font-size:16px;"
                        @click="appendexId = scope.row.id,subject = 'ppt43'"
                      ></i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column label="网络教学16:9" width="120" align="center">
                  <template slot-scope="scope">
                    <i
                      v-if="scope.row.ppt169!=null"
                      class="research-icon el-icon-video-play"
                      style="font-size:16px;"
                      @click="pptPlay(scope.row)"
                    ></i>
                    <el-upload
                      v-if="scope.row.ppt169!=null"
                      style="display:initial"
                      class="upload-demo"
                      :action="fileAction"
                      :on-success="pptHandleSuccess"
                      :headers="reqData"
                      :file-list="fileList"
                    >
                      <el-button
                        type="text"
                        @click="replacePPT(scope.row.ppt169),appendexId = scope.row.id,subject = 'ppt169'"
                      >替换</el-button>
                    </el-upload>
                    <el-upload
                      v-if="scope.row.ppt169==null"
                      style="display:initial"
                      class="upload-demo"
                      :action="fileAction"
                      :on-success="pptHandleSuccess"
                      :headers="reqData"
                      :file-list="fileList"
                    >
                      <i
                        class="research-icon el-icon-upload"
                        style="font-size:16px;"
                        @click="appendexId = scope.row.id,subject = 'ppt169'"
                      ></i>
                    </el-upload>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>-->
          </el-tabs>
        </div>
      </div>

      <el-dialog title="提示" :visible.sync="noteDialogVisible" class="previewBox" :close-on-click-modal="false">
        <img src="../../../static/image/phone.png" class="mobileBg" />

        <div class="content">
          <div class="content-top">
            上课讲义
            <div class="content-buttom" @click="noteDialogVisible = false;">关闭</div>
          </div>
          <div v-html="content"></div>
          <!-- <span v-html="articleDetail.ArticleContent">11111111</span> -->
          <!-- <div class="attachList">
                    <a v-for="(item,index) in articleDetail.Ex_Attach" :href="item.FilePath">
                        {{item.FileName}}
                    </a>
          </div>-->
        </div>
      </el-dialog>

      <el-dialog title="自定义视频" :visible.sync="dataDialogVisible" :close-on-click-modal="false" width="60%">
        <div style="margin-botton:20px;height:40px;">
          <el-upload style="float:left" class="upload-demo" :action="fileAction" :on-success="handleSuccess" :headers="reqData" :file-list="fileList">
            <el-button type="primary">点击上传</el-button>
            <span style="margin-left:20px;">常规文档格式，不能超10M</span>
          </el-upload>
          <el-button type="primary" style="float:right;" @click="addDefaultVideoMaterials">添加</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%;margin-top:20px;">
          <el-table-column prop="name" label="附件"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <i class="research-icon el-icon-download" @click="down(scope.row)"></i>
              <i class="research-icon el-icon-delete" @click="delect(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog :title="nameDialogVisibleTitle" :visible.sync="defaultnameDialogVisible" :close-on-click-modal="false" width="25%">
        <el-form ref="classRoomSearch" label-width="80px">
          <el-form-item prop="title" :label="contentName">
            <el-input clearable v-model="defaultChapterMaterialsName" :placeholder="'请输入' + nameDialogVisibleTitle"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="defaultnameDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="batchAddDefaultChapterMaterials">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="nameDialogVisibleTitle" :visible.sync="nameDialogVisible" :close-on-click-modal="false" width="25%">
        <el-form ref="classRoomSearch" label-width="80px">
          <el-form-item prop="title" :label="contentName">
            <el-input clearable v-model="chapterMaterialsName" :placeholder="'请输入' + nameDialogVisibleTitle"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nameDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="batchAddChapterMaterials">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="从题库选择" :visible.sync="questionDialogVisible" :close-on-click-modal="false" width="60%">
        <el-form ref="classRoomSearch" :model="classRoomSearch" :label-width="formLabelWidth">
          <el-row :gutter="20">
            <el-col :sm="24" :md="6" :lg="6">
              <el-form-item prop="questionTypeId">
                <el-select style="width:100%" filterable clearable v-model="classRoomSearch.knowledgeId" placeholder="请输入考点">
                  <el-option v-for="item in KnowledgeTree" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-form-item prop="questionTypeId">
                <el-select style="width:100%" clearable v-model="classRoomSearch.questionTypeId" placeholder="请输入题型">
                  <el-option v-for="item in classRoomTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6">
              <el-form-item prop="title">
                <el-input clearable v-model="classRoomSearch.title" placeholder="请输入题干" auto-complete="off" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="3" :lg="3">
              <el-button type="primary" class="classRoomButton" @click="classRoomPageList()">查询</el-button>
            </el-col>
            <el-col :sm="24" :md="3" :lg="3">
              <el-button type="primary" class="classRoomButton" style="float:right;width:80px;" @click="openNameDialogVisible">添加</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table ref="multipleTable" :data="classRoomList.records" style="width: 100%;margin-top: 10px;" row-key="id" border @selection-change="selectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="排序" width="50"></el-table-column>
          <el-table-column prop="questionTypeName" label="类型" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="title" show-overflow-tooltip label="题干">
            <template slot-scope="scope">
              <div class="message">
                <div class="htmltittle" v-html="scope.row.title"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="answer" label="答案" align="center" width="60" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.big!=1">{{scope.row.answer||"-"}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: left;" :total="classRoomList.total" :page-size="classRoomList.pageSize" :page-sizes="[10, 20, 30, 40]" :current-page="classRoomList.pageNumber" @size-change="classRoomSizeChange" @current-change="classRoomCurrentChange"></el-pagination>
      </el-dialog>

      <el-dialog title="预览视频" @close="closeDialog" :visible.sync="videoDialog" :close-on-click-modal="false" width="70%">
        <div class="videoPlay">
          <div class="videoPlay-left">
            <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
          </div>
          <div class="videoPlay-right">
            <el-tree :data="VideoTree" :props="VideoProps" class="research-tree">
              <span class="span-ellipsis" slot-scope="{ node, data }">
                <span :title="data.name" @click="choseVideoId(data);">{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      admin: JSON.parse(localStorage.getItem("user")).admin,
      formLabelWidth: "0px",
      noteDialogVisible: false,
      questionDialogVisible: false,
      defaultnameDialogVisible: false,
      nameDialogVisible: false,
      dataDialogVisible: false,
      videoDialog: false,
      bindVisible: false,
      nameDialogVisibleTitle: "",
      contentName: "",
      classRoomList: {},
      classRoomTypeList: [],
      courseIds: [],
      chapterName: "",
      subjectTreeList: [],
      KnowledgeTree: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      searchForm: {},
      ChapterTree: [],
      ChapterProps: {
        children: "children",
        label: "name"
      },
      defaultChapterMaterialsName: "",
      chapterMaterialsName: "",
      custom: 1,
      VideoTree: [],
      VideoProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      activeName: "first",
      chapterId: "",
      teachingResearchList: [],
      courseVideoList: [],
      classRoomSearch: {
        pageNumber: 1,
        pageSize: 10
      },
      itemId: [],
      fileAction: `${process.env.BASE_URL}/chapterMaterials/upload`,
      fileList: [],
      pptList: [],
      tableData: [],
      pptTableData: {},
      content: "",
      ids: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      addChapterMaterialsId: "",
      chapterMaterialsType: 1,
      type: 2,
      appendexId: 0,
      subject: ""
    };
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    }
  },
  // created() {
  //   this.$nextTick(function() {
  //     console.log("1111111111111",this.ChapterTree);
  //     this.$refs.tree.setCurrentKey(this.ChapterTree[0].id);
  //   });
  // },
  methods: {
    closeDialog () {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    handleSuccess (response, file, fileList, $event) {
      let obj = {
        name: file.raw.name,
        size: file.raw.size,
        type: file.raw.type,
        url: response.data.url,
        objectId: this.appendexId
      };
      this.api.attachment.addAttachment(obj).then(result => {
        if (result.success) {
          this.tableData.push(obj);
          for (let i in this.tableData) {
            this.tableData[i].index = i;
            this.tableData[i].url = this.tableData[i].url.split("?")[0];
          }
        }
      });
    },
    pptHandleSuccess (response, file, fileList, $event) {
      console.log("this.appendexId", this.appendexId);
      let obj = {
        name: file.raw.name,
        size: file.raw.size,
        type: file.raw.type,
        url: response.data.url,
        objectId: this.appendexId,
        subject: this.subject
      };
      this.api.attachment.addAttachment(obj).then(result => {
        if (result.success) {
          // this.pptTableData.url = obj.url.split("?")[0];
          this.getDataList();
        }
      });
    },
    pptPlay (item) {
      item = item.ppt43.url.split("?")[0];
      localStorage.setItem("jump", JSON.stringify({ url: item }));
      this.$router.push({ path: "PPTPlay" });
      // window.open("https://view.officeapps.live.com/op/view.aspx?src="+item)
    },
    replacePPT (item) {
      // this.$confirm("是否确认替换？", "系统消息", {
      //   type: "warning"
      // })
      //   .then(() => {
      let obj = {
        id: item.id
      };
      this.api.attachment.deleteAttachment([obj]).then(result => { });
      // })
      // .catch(error => {
      //   console.log(error);
      // });
    },
    down (item) {
      window.open(item.url);
    },
    delect (item) {
      this.$confirm("系统将删除该附件，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          let obj = {
            id: item.id
          };
          this.api.attachment.deleteAttachment([obj]).then(result => { });
          this.tableData.splice(item.index, 1);
        })
        .catch(error => {
          console.log(error);
        });
    },
    openZiNote (item) {
      console.log(item);
      this.content = item.content;
      this.noteDialogVisible = true;
    },
    openNote (item) {
      console.log(item);
      this.content = item.chapterMaterials.content;
      this.noteDialogVisible = true;
    },
    openVideo (item) {
      this.api.chapter.chapterVideoList({ chapterId: item.id }).then(result => {
        if (result.success) {
          this.VideoTree = result.data;
          this.playerOptions.sources[0].src = this.VideoTree[0].url;
          this.videoDialog = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    openZiVideo (item) {
      this.api.chapterMaterials
        .getChapterMaterials({ id: item.id })
        .then(result => {
          if (result.success) {
            this.VideoTree = result.data.attachments;
            this.playerOptions.sources[0].src = this.VideoTree[0].url;
            this.videoDialog = true;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    openDataDialogVisible (item) {
      this.api.attachment
        .getAttachmentList({ objectId: item.id })
        .then(result => {
          if (result.success) {
            this.tableData = result.data;
          }
        });
      this.appendexId = item.id;
      this.dataDialogVisible = true;
    },
    goZiAddNote (item, row) {
      let jump = {};
      jump = {
        chapterId: item.id,
        type: this.chapterMaterialsType,
        state: row
      };
      localStorage.setItem("jump", JSON.stringify(jump));
      this.$router.push({
        path: "/addNote"
      });
    },
    goAddNote (item, row) {
      console.log("item", item);
      let jump = {};
      if (item.chapterMaterials) {
        jump = {
          chapterId: item.chapterMaterials.id,
          type: this.chapterMaterialsType,
          state: row
        };
      } else {
        jump = {
          chapterId: item.id,
          type: this.chapterMaterialsType,
          state: row
        };
      }
      localStorage.setItem("jump", JSON.stringify(jump));
      this.$router.push({
        path: "/addNote"
      });
    },
    goAddVideo (item, row) {
      console.log("item", item);
      let jump = {};
      jump = {
        chapterId: item.id,
        type: this.chapterMaterialsType,
        state: row
      };
      localStorage.setItem("jump", JSON.stringify(jump));
      this.$router.push({
        path: "/addVideo"
      });
    },
    // goAddVideo(item, row) {
    //   this.bindVisible = true;
    // },

    addDefaultVideoMaterials () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.chapterMaterials
            .addDefaultChapterMaterials(this.addForm)
            .then(result => {
              console.log(result);
              if (result.success) {
                this.$router.push({
                  path: "/teachingResearch"
                });
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateDefaultVideoMaterials () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.chapterMaterials
            .updateDefaultChapterMaterials(this.addForm)
            .then(result => {
              if (result.success) {
                this.$router.push({
                  path: "/teachingResearch"
                });
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },

    subjectSearchChange () {
      this.searchForm.courseId = this.courseIds[2];
      this.teachingResearchList = [];
      this.courseVideoList = [];
      this.getTree();
    },
    // 获取课程
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          this.teachingResearchList = [];
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  if (items.children) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.subjectTreeList = result.data;
            this.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.searchForm.courseId = this.subjectTreeList[0].children[0].children[0].id;
            this.getTree();
            // this.getClassInfoList();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // getClassInfoList() {
    //   this.api.classInfo
    //     .getClassInfoList({ courseId: this.searchForm.courseId })
    //     .then(result => {
    //     })
    // },
    getTree () {
      this.api.chapter
        .getChapterSelectListByCourse({ courseId: this.searchForm.courseId })
        .then(result => {
          this.ChapterTree = result.data;
          if (this.ChapterTree.length > 0) {
            this.activeName = "first";
            this.chapterName = this.ChapterTree[0].children[0].name;
            this.chapterMaterialsType = 1;
            this.type = 2;
            this.itemId = this.ChapterTree[0].children[0];
            this.addChapterMaterialsId = this.ChapterTree[0].children[0].id;
            this.$nextTick(function () {
              this.$refs.tree.setCurrentKey(this.addChapterMaterialsId);
            });
            this.getDataList();
          } else {
            this.activeName = "first";
            this.teachingResearchList = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    choseChapterId (item) {
      this.teachingResearchList = [];
      if (item.children != null && item.children != []) {
        this.type = 1;
      } else {
        this.type = 2;
      }
      this.chapterName = item.name;
      this.itemId = item;
      this.getDataList();
    },
    choseVideoId (item) {
      this.playerOptions.sources[0].src = item.url;
    },
    getDataList () {
      if (this.chapterMaterialsType == 4) {
        // this.getChapterListVideoByPid();
        this.getChapterMaterialsList();
      } else {
        this.getChapterMaterialsList();
      }
    },
    getChapterMaterialsList () {
      let obj = {
        id: this.itemId.id,
        type: this.type,
        chapterMaterialsType: this.chapterMaterialsType
      };
      this.api.chapter
        .chapterMaterialsList(obj)
        .then(result => {
          if (result.success) {
            this.teachingResearchList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getChapterListVideoByPid () {
      this.api.chapter
        .getChapterListVideoByPid({ chapterId: this.itemId.id })
        .then(result => {
          this.courseVideoList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteChapterMaterials (id, row) {
      let name = "";
      if (row === 1) {
        name = "讲义";
      } else if (row === 2) {
        name = "课堂练习";
      } else if (row === 3) {
        name = "课后作业";
      } else if (row === 4) {
        name = "视频";
      }
      this.$confirm("将会删除此" + name + "，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          let obj = { id: id };
          this.api.chapterMaterials
            .deleteChapterMaterials([obj])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                // this.activeName = "first";
                // this.getChapterMaterialsList(this.itemId, 1);
                this.getChapterMaterialsList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    choseQuestion (item, row) {
      this.custom = row;
      this.addChapterMaterialsId = item.id;
      this.classRoomPageList();
      this.getKnowledgeSelectListByCourse();
      this.classRoomType();
      this.questionDialogVisible = true;
    },

    //课堂练习

    goTestQuestions (row, limit, chapterId) {
      let obj = {
        id: row.id,
        limit: limit,
        type: this.chapterMaterialsType,
        chapterType: this.type,
        chapterId: chapterId,
        courseId: this.searchForm.courseId
      };
      localStorage.setItem("jump", JSON.stringify(obj));
      this.$router.push({
        path: "/testQuestions"
      });
    },
    // 获取知识点列表
    getKnowledgeSelectListByCourse () {
      this.api.chapter
        .getKnowledgeSelectListByCourse({
          courseId: this.searchForm.courseId,
          keyword: ""
        })
        .then(result => {
          this.KnowledgeTree = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取试题类型
    classRoomType () {
      this.api.question
        .questionTypeList()
        .then(result => {
          this.classRoomTypeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    classRoomPageList () {
      this.api.question
        .pageList(this.classRoomSearch)
        .then(result => {
          this.classRoomList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    openNameDialogVisible () {
      if (this.custom === 1) {
        this.batchAddDefaultChapterMaterialsName();
      } else if (this.custom === 2) {
        this.batchAddChapterMaterialsName();
      } else if (this.custom === 3) {
        this.batchAddDefaultChapterMaterialsName();
      } else if (this.custom === 4) {
        this.batchAddChapterMaterialsName();
      }
    },

    batchAddChapterMaterialsName () {
      if (this.custom === 2) {
        this.nameDialogVisibleTitle = "自定义课堂练习名称";
        this.contentName = "练习名称";
      } else if (this.custom === 4) {
        this.nameDialogVisibleTitle = "自定义课后作业名称";
        this.contentName = "作业名称";
      }
      this.nameDialogVisible = true;
    },
    batchAddChapterMaterials () {
      if (this.ids === []) {
        this.$message.error("请选择需要添加的题目");
      } else {
        let obj = {
          chapterId: this.addChapterMaterialsId,
          questionIds: this.ids,
          type: this.chapterMaterialsType,
          chapterType: this.type,
          title: this.chapterMaterialsName
        };
        this.api.chapterMaterials.batchAddChapterMaterials(obj).then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.getChapterMaterialsList();
            this.questionDialogVisible = false;
            this.nameDialogVisible = false;
            this.chapterMaterialsName = "";
          } else {
            this.$message.error(result.messages);
          }
        });
      }
    },

    batchAddDefaultChapterMaterialsName () {
      if (this.custom === 1) {
        this.nameDialogVisibleTitle = "标准课堂练习名称";
        this.contentName = "练习名称";
      } else if (this.custom === 3) {
        this.nameDialogVisibleTitle = "标准课后作业名称";
        this.contentName = "作业名称";
      }
      this.defaultnameDialogVisible = true;
    },
    batchAddDefaultChapterMaterials () {
      if (this.ids === []) {
        this.$message.error("请选择需要添加的题目");
      } else {
        let obj = {
          chapterId: this.addChapterMaterialsId,
          questionIds: this.ids,
          type: this.chapterMaterialsType,
          chapterType: this.type,
          title: this.defaultChapterMaterialsName
        };
        this.api.chapterMaterials
          .batchAddDefaultChapterMaterials(obj)
          .then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.getChapterMaterialsList();
              this.questionDialogVisible = false;
              this.defaultnameDialogVisible = false;
              this.defaultChapterMaterialsName = "";
            } else {
              this.$message.error(result.messages);
            }
          });
      }
    },
    classRoomSizeChange (pageSize) {
      this.classRoomSearch.pageSize = pageSize;
      this.classRoomPageList();
    },
    classRoomCurrentChange (pageNumber) {
      this.classRoomSearch.pageNumber = pageNumber;
      this.classRoomPageList();
    },
    selectionChange (val) {
      let arr = [];
      this.multipleSelection = val;
      val.map(e => arr.push(e.id));
      this.ids = arr;
    },
    handleClick (tab, event) {
      console.log(tab, event);
      if (tab.name == "first") {
        this.teachingResearchList = [];
        this.chapterMaterialsType = 1;
        this.getChapterMaterialsList();
      }
      if (tab.name == "second") {
        this.teachingResearchList = [];
        this.chapterMaterialsType = 2;
        this.getChapterMaterialsList();
      }
      if (tab.name == "third") {
        this.teachingResearchList = [];
        this.chapterMaterialsType = 3;
        this.getChapterMaterialsList();
      }
      if (tab.name == "fourth") {
        this.teachingResearchList = [];
        this.chapterMaterialsType = 4;
        // this.getDataList();
        this.getChapterMaterialsList();
      }
      if (tab.name == "five") {
        this.teachingResearchList = [];
        this.chapterMaterialsType = 5;
        this.getChapterMaterialsList();
      }
      if (tab.name == "six") {
        this.teachingResearchList = [];
        this.chapterMaterialsType = 6;
        this.getChapterMaterialsList();
      }
    }
  },
  watch: {
    dataDialogVisible: function (newVal) {
      if (!newVal) {
        this.getChapterMaterialsList();
      } else {
      }
    }
  },
  mounted () {
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.research {
  background-color: #fff;
}
.research-left {
  width: 20%;
  border-right: 1px solid rgba(238, 238, 238, 1);
}
.research-right {
  width: 80%;
}
.tab-type {
  padding: 20px;
  /* padding-top: 10px; */
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 48px;
  line-height: 48px;
}
.left-top-text {
  float: left;
}
.left-top-botton {
  margin-top: 10px;
  float: right;
}
.research-search {
  padding: 0px 20px;
}
.research-select {
  width: 100%;
  margin-top: 20px;
}
.research-tree {
  margin-top: 10px;
  padding-bottom: 20px;
}
.research-icon {
  margin: 0px 10px;
  font-size: 13px;
  color: #409eff;
}
.research-icon-right {
  float: right;
  margin: 10px;
  font-size: 13px;
  color: #409eff;
}
.classRoomButton {
  /* height: 40px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 40px;
  color: #fff; */
  font-size: 14px;
  cursor: pointer;
}
.addNote-button {
  height: 32px;
  width: 100px;
  border: 1px solid rgba(77, 148, 255, 1);
  color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 34px;
  cursor: pointer;
}
.videoPlay {
  display: flex;
}
.videoPlay-left {
  width: 75%;
}
.videoPlay-right {
  width: 25%;
  background-color: rgba(246, 249, 250, 1);
  padding: 10px;
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  background-color: rgb(255, 255, 255);
  color: rgb(64, 158, 255);
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgb(255, 255, 255);
  color: rgb(64, 158, 255);
}
</style>
<style lang="less">
.research {
  .el-card__body {
    padding: 0px !important;
  }
  .el-upload-list {
    display: none !important;
  }
  .el-tabs__nav-scroll {
    height: 49px !important;
    line-height: 49px;
  }
  .el-tabs__nav {
    margin-left: 20px;
  }
  .previewBox {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    .el-dialog {
      width: 320px;
      height: 606px;
      margin: inherit;
      border-radius: 50px;
      margin-top: 0 !important;
      .el-dialog__header {
        height: 0;
        width: 0;
        padding: 0;
        opacity: 0;
      }
      .el-dialog__body {
        padding: 0;
        .mobileBg {
          width: 324px;
          height: 606px;
        }
        .content {
          position: relative;
          top: -540px;
          left: 22px;
          width: 280px;
          line-height: 20px;
          font-size: 15px;
          height: 460px !important;
          overflow-y: scroll;
          margin: 0;
          overflow-x: hidden;
          .content-top {
            height: 44px;
            line-height: 44px;
            text-align: center;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
          }
          .content-buttom {
            width: 40px;
            line-height: 28px;
            border: 1px solid rgba(238, 238, 238, 1);
            color: #37aefe;
            text-align: center;
            cursor: pointer;
            position: relative;
            top: -35px;
            left: 225px;
          }
          .attachList {
            margin-bottom: 20px;
            a {
              text-decoration: none;
            }
          }
        }
      }
    }
    img {
      max-width: 100%;
    }
  }
  // .research-tree {
  //   padding-bottom: 0px;
  //   .el-tree-node__label {
  //     font-size: 13px;
  //     color: #a2aabc;
  //   }
  // }
  // .el-tree-node:focus > .el-tree-node__content {
  //   color: #409EFF;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/teachingContent/index.vue